export default __webpack_public_path__ + "static/media/technician-01.ff20289f.jpg";